import {Box} from '@primer/react'
import type React from 'react'

// TODO: Migrate this to @github-ui/visually-hidden
//
// Re-writing this as the styled components version above does not play well with React SSR: hydration fails because
// class names are generated on the fly, meaning server classNames don't match client classNames
export const VisuallyHidden = (props: React.PropsWithChildren) => {
  return (
    <Box
      as="span"
      sx={{
        border: 0,
        clip: 'rect(0 0 0 0)',
        height: '1px',
        width: '1px',
        margin: '-1px',
        overflow: 'hidden',
        padding: 0,
        position: 'absolute',
      }}
    >
      {props.children}
    </Box>
  )
}

try{ VisuallyHidden.displayName ||= 'VisuallyHidden' } catch {}